import * as types from 'src/store/types';

const mutations = {
  [types.SET_LANG_CHANGE](state, lang) {
    state.currentLang = lang;
  },
  [types.SET_ALARM_SHOW](state, bool) {
    state.isShowAlarm = bool;
  },
  [types.SET_ADBLOCK_ALERT](state, bool) {
    state.showAdblockAlert = bool;
  },
  [types.SET_VISIT_LITE](state, bool) {
    state.showVisitLiteTips = bool;
  },
  [types.SET_NOTIFY_ALERT](state, bool) {
    state.isShowDemoteNotify = bool;
  },
  [types.SET_TTP_NOTIFY_ALERT](state, bool) {
    state.isShowTTPDemoteNotify = bool;
  },
  [types.SET_IS_ATHENA_CALLER_READY](state, bool) {
    state.isAthenaCallerReady = bool;
  },
  [types.SET_HAS_ATHENA_CALLER](state, bool) {
    state.hasAthenaCaller = bool;
  },
  [types.SET_HAS_ATHENA_CALLER_CHECK_COMPLETED](state, bool) {
    state.hasAthenaCallerCheckCompleted = bool;
  },
};
export default mutations;
